"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var crypto_1 = __importDefault(require("crypto"));
//Rounds length down by 1 if it is an odd number
function generateRandomString(length) {
    if (length % 2 !== 0)
        return crypto_1.default.randomBytes((length - 1) / 2).toString('hex');
    return crypto_1.default.randomBytes(length / 2).toString('hex');
}
exports.default = generateRandomString;
//# sourceMappingURL=generate-random-string.js.map